//Klaviyo heading
(function () {
  var MATCH_TEXT = 'Join the ABS Club';

  function convertToH2(h1) {
    if (h1.dataset.a11yConverted === 'true') return;

    var h2 = document.createElement('h2');

    // Copy every attribute (style, class, etc.) as-is
    Array.prototype.forEach.call(h1.attributes, function (attr) {
      h2.setAttribute(attr.name, attr.value);
    });

    // Preserve the exact inner markup (nested spans and inline styles)
    h2.innerHTML = h1.innerHTML;
    h2.dataset.a11yConverted = 'true';

    h1.replaceWith(h2);
  }

  function scan(root) {
    (root.querySelectorAll ? root.querySelectorAll('h1') : []).forEach(function (h1) {
      if (h1.textContent.replace(/\s+/g, ' ').trim().indexOf(MATCH_TEXT) !== -1) {
        convertToH2(h1);
      }
    });
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scan(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  scan(document);
})();
//Empty Alt
(function () {
  function fixMissingAlt(root) {
    var images = root.querySelectorAll ? root.querySelectorAll('img:not([alt])') : [];
    images.forEach(function (img) {
      img.setAttribute('alt', '');
    });
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.tagName === 'IMG' && !node.hasAttribute('alt')) {
      node.setAttribute('alt', '');
    }
    fixMissingAlt(node);
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(scan);
      // Catch cases where an existing <img> has its alt attribute removed
      if (m.type === 'attributes' && m.target.tagName === 'IMG' && !m.target.hasAttribute('alt')) {
        m.target.setAttribute('alt', '');
      }
    });
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['alt']
  });

  // Catch everything already on the page when this script runs
  fixMissingAlt(document);
})();
//search heading tag
(function () {
  'use strict';

  function fixHeading(container) {
    var h6 = container.querySelector('h6.recent-search-title');
    if (!h6) return;

    var h3 = document.createElement('h3');
    // Copy all attributes (class, etc.) over
    Array.prototype.forEach.call(h6.attributes, function (attr) {
      h3.setAttribute(attr.name, attr.value);
    });
    h3.innerHTML = h6.innerHTML;

    h6.replaceWith(h3);
  }

  function init() {
    document.querySelectorAll('.recent-search-list').forEach(fixHeading);
  }

  init();

  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(init, 50);
  }).observe(document.body, { childList: true, subtree: true });
})();
//Merchant frame title
  (function () {
    var TITLE = 'Google Customer Reviews and Merchant Information';

    function setTitle() {
      var iframe = document.getElementById('merchantwidgetiframe');
      if (iframe && !iframe.getAttribute('title')) {
        iframe.setAttribute('title', TITLE);
      }
      return !!iframe;
    }

    // Already on the page
    setTitle();

    // Otherwise watch for Google to inject it
    var observer = new MutationObserver(function () {
      setTitle();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Stop watching after 30 seconds to avoid needless work
    setTimeout(function () {
      observer.disconnect();
    }, 30000);
  })();
  //judge me image alt
  (function () {
    var SELECTOR = '.jdgm-svg__mono';

    function hideDecorative(root) {
      var icons = (root || document).querySelectorAll(SELECTOR);
      icons.forEach(function (el) {
        if (el.getAttribute('data-a11y-fixed')) return;

        // Remove the unnamed image role and hide from screen readers
        el.removeAttribute('role');
        el.setAttribute('aria-hidden', 'true');

        // Make sure the inner SVG isn't focusable or announced either
        var svg = el.querySelector('svg');
        if (svg) {
          svg.setAttribute('aria-hidden', 'true');
          svg.setAttribute('focusable', 'false');
        }

        el.setAttribute('data-a11y-fixed', 'true');
      });
    }

    // Run on anything already on the page
    hideDecorative();

    // Catch icons Judge.me adds or re-renders later
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        hideDecorative();
      });
    }).observe(document.body, { childList: true, subtree: true });
  })();
  //announcement bar
  document.addEventListener('DOMContentLoaded', function () {
  const focusableSelector =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]';

  function syncFocusability(slide) {
    const isHidden = slide.getAttribute('aria-hidden') === 'true';
    const focusables = slide.querySelectorAll(focusableSelector);

    focusables.forEach(function (el) {
      if (isHidden) {
        if (!el.hasAttribute('data-original-tabindex') && el.hasAttribute('tabindex')) {
          el.setAttribute('data-original-tabindex', el.getAttribute('tabindex'));
        }
        el.setAttribute('tabindex', '-1');
      } else {
        if (el.hasAttribute('data-original-tabindex')) {
          el.setAttribute('tabindex', el.getAttribute('data-original-tabindex'));
          el.removeAttribute('data-original-tabindex');
        } else {
          el.removeAttribute('tabindex');
        }
      }
    });
  }

  // Watch every Flickity slide inside announcement bars (and any other
  // Flickity-powered carousel) for aria-hidden changes
  document.querySelectorAll('.announcement-bar__message, .flickity-slider > *').forEach(function (slide) {
    // Run once immediately for current state on load
    syncFocusability(slide);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'aria-hidden') {
          syncFocusability(slide);
        }
      });
    });

    observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
  });
});
//yv banner
(function () {
  const focusableSelector =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function makeSlideInert(slide) {
    const isHidden = slide.getAttribute('aria-hidden') === 'true';

    // Modern browsers – strongest protection
    if ('inert' in HTMLElement.prototype) {
      slide.inert = isHidden;
    }

    // Classic tabindex approach (still needed for older browsers + Lighthouse)
    const focusables = slide.querySelectorAll(focusableSelector);
    focusables.forEach(function (el) {
      if (isHidden) {
        if (!el.hasAttribute('data-original-tabindex')) {
          const current = el.getAttribute('tabindex');
          el.setAttribute('data-original-tabindex', current !== null ? current : '');
        }
        el.setAttribute('tabindex', '-1');
        // Extra safety for some accessibility scanners
        el.setAttribute('aria-hidden', 'true');
      } else {
        if (el.hasAttribute('data-original-tabindex')) {
          const original = el.getAttribute('data-original-tabindex');
          if (original === '') {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', original);
          }
          el.removeAttribute('data-original-tabindex');
        } else {
          el.removeAttribute('tabindex');
        }
        el.removeAttribute('aria-hidden');
      }
    });
  }

  function syncAllSlides() {
    document.querySelectorAll('.yv-banner-item[role="tabpanel"], .flickity-slider > .yv-banner-item').forEach(makeSlideInert);
  }

  // 1. Run as soon as possible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllSlides);
  } else {
    syncAllSlides();
  }

  // 2. Keep watching the entire slider for any aria-hidden changes
  const slider = document.querySelector('.banner-fullwidth-slides, .full-width-slider-section, [data-flickity-slider]');
  if (slider) {
    const observer = new MutationObserver(function (mutations) {
      let needsSync = false;
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'aria-hidden') {
          needsSync = true;
        }
        if (m.type === 'childList') {
          needsSync = true;
        }
      });
      if (needsSync) {
        // Small delay so Flickity finishes its own attribute writes
        setTimeout(syncAllSlides, 30);
      }
    });

    observer.observe(slider, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      childList: true,
      subtree: true
    });
  }

  // 3. Also listen to Flickity’s own events (most reliable)
  function attachFlickityListeners() {
    const flickityEl = document.querySelector('.banner-fullwidth-slides.flickity-enabled, .full-width-slider-section.flickity-enabled');
    if (!flickityEl || !window.Flickity) return;

    // Get the Flickity instance
    const flkty = Flickity.data(flickityEl) || new Flickity(flickityEl);
    if (!flkty) return;

    ['select', 'settle', 'change', 'ready'].forEach(function (evt) {
      flkty.on(evt, function () {
        setTimeout(syncAllSlides, 20);
      });
    });
  }

  // Try immediately and also after a short delay (Flickity often initialises late)
  attachFlickityListeners();
  setTimeout(attachFlickityListeners, 500);
  setTimeout(attachFlickityListeners, 1500);

  // Final safety net – re-sync every few seconds while the page is open
  // (very cheap and catches any edge cases)
  setInterval(syncAllSlides, 3000);
})();
//aria hidden product slider
/*
 * aria-hidden-focus-fix.js
 * Guarantees that an element with aria-hidden="true" is not focusable and contains nothing focusable.
 * Works with Flickity, which adds/removes aria-hidden on carousel cells as the carousel moves.
 *
 * - Locked:   every focusable node inside (or on) an aria-hidden="true" element gets tabindex="-1";
 *             product cards are also made inert.
 * - Restored: when aria-hidden goes away, the original tabindex is put back
 *             (unless the node is still inside another aria-hidden area, e.g. the decorative image link).
 * - Live:     a MutationObserver re-applies the rule when aria-hidden changes, when something
 *             (e.g. Flickity) sets tabindex inside a hidden area, or when new nodes are added.
 */
(function () {
  'use strict';

  var SCOPE = '.yv-collection-product-grid';
  var FOCUSABLE = [
    'a[href]', 'area[href]', 'button', 'input:not([type="hidden"])', 'select', 'textarea',
    'summary', 'iframe', '[contenteditable="true"]', 'audio[controls]', 'video[controls]', '[tabindex]'
  ].join(',');
  var KEY = 'data-ah-tabindex';

  function isHidden(el) { return el.getAttribute('aria-hidden') === 'true'; }
  function insideHidden(el) { return !!el.closest('[aria-hidden="true"]'); }
  function isCard(el) { return el.classList && el.classList.contains('yv-product-card'); }

  function lockNode(n) {
    if (!n.hasAttribute(KEY)) n.setAttribute(KEY, n.hasAttribute('tabindex') ? n.getAttribute('tabindex') : '');
    if (n.getAttribute('tabindex') !== '-1') n.setAttribute('tabindex', '-1');
  }

  function restoreNode(n) {
    if (!n.hasAttribute(KEY)) return;
    var v = n.getAttribute(KEY);
    if (v === '') n.removeAttribute('tabindex'); else n.setAttribute('tabindex', v);
    n.removeAttribute(KEY);
  }

  function eachFocusable(root, fn) {
    if (root.matches(FOCUSABLE)) fn(root);
    Array.prototype.forEach.call(root.querySelectorAll(FOCUSABLE), fn);
  }

  function hide(el) {
    eachFocusable(el, lockNode);
    if (isCard(el) && 'inert' in el) el.inert = true;
  }

  function show(el) {
    if (isCard(el) && 'inert' in el) el.inert = false;
    eachFocusable(el, function (n) { if (!insideHidden(n)) restoreNode(n); });
  }

  function onMutations(muts) {
    muts.forEach(function (m) {
      var t = m.target;
      if (m.type === 'attributes') {
        if (m.attributeName === 'aria-hidden') {
          if (isHidden(t)) hide(t); else show(t);
        } else if (t.getAttribute('tabindex') !== '-1' && insideHidden(t)) {
          lockNode(t); // something set tabindex inside a hidden area
        }
      } else {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType === 1 && insideHidden(n)) eachFocusable(n, lockNode);
        });
      }
    });
  }

  function init(grid) {
    if (grid.__ahFocusFix) return;
    grid.__ahFocusFix = true;
    Array.prototype.forEach.call(grid.querySelectorAll('[aria-hidden="true"]'), hide);
    new MutationObserver(onMutations).observe(grid, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden', 'tabindex']
    });
  }

  function scan() { Array.prototype.forEach.call(document.querySelectorAll(SCOPE), init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan); // theme editor re-renders
})();
//announcement tabindex
(function () {
  var SEL = '.announcement-bar-wrapper.flickity-enabled';

  function stripTabindex(el) {
    if (el.hasAttribute('tabindex')) {
      el.removeAttribute('tabindex');
    }
  }

  function scan(root) {
    (root.querySelectorAll ? root.querySelectorAll(SEL) : []).forEach(stripTabindex);
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      // New wrapper elements appearing
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(SEL)) stripTabindex(node);
        scan(node);
      });
      // Flickity re-adding tabindex to an existing wrapper
      if (m.type === 'attributes' && m.attributeName === 'tabindex' && m.target.matches && m.target.matches(SEL)) {
        stripTabindex(m.target);
      }
    });
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['tabindex']
  });

  // Catch it if already present when this script runs
  scan(document);
})();
//popup focus
/*
 * popup-focus-lock.js
 * Closed popups (mini cart, similar-products drawer, mobile menu, search bar) must not be keyboard-reachable.
 *
 * How it works
 * - It NEVER changes tabindex on the popup wrapper (tabindex="0" stays exactly as is, so the theme's
 *   "move focus to the popup" logic keeps working). It only sets `inert` on the wrapper's DIRECT CHILDREN
 *   while the popup is closed. `inert` = not focusable, not clickable, hidden from screen readers,
 *   and it also covers content the theme re-renders inside those children (e.g. cart contents).
 * - "Open" is detected from what is really on screen (IntersectionObserver + computed style), so it does not
 *   depend on the theme's class names. Sliding in/out, fading, clipping or display:none are all handled.
 * - Any click (mouse, touch or Enter/Space on the opener) briefly unlocks every popup before the theme's own
 *   handler runs, so focus() calls made right after opening still land.
 */
(function () {
  'use strict';

  /* ---------------- config ---------------- */
  var POPUPS = '[data-side-drawer], [data-similar-product-drawer], #mobileMenu, .search-bar-container';
  // false = never touch the wrapper's tabindex (default, as requested).
  // true  = also set the wrapper's own tabindex to -1 while closed and restore the original value when open.
  var LOCK_WRAPPER_TABSTOP = true;
  var UNLOCK_MS = 250;
  /* ---------------------------------------- */

  if (!('IntersectionObserver' in window) || !('inert' in HTMLElement.prototype)) return;

  var popups = [];
  var SKIP = /^(SCRIPT|STYLE|TEMPLATE|LINK)$/;

  function styleVisible(el) {
    var cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05;
  }

  function kidsOf(p) {
    return Array.prototype.filter.call(p.children, function (k) { return !SKIP.test(k.tagName); });
  }

  function wrapperTabstop(p, open) {
    if (!open) {
      if (!p.hasAttribute('data-pfl-tabindex')) {
        p.setAttribute('data-pfl-tabindex', p.hasAttribute('tabindex') ? p.getAttribute('tabindex') : '');
      }
      p.setAttribute('tabindex', '-1');
    } else if (p.hasAttribute('data-pfl-tabindex')) {
      var v = p.getAttribute('data-pfl-tabindex');
      if (v === '') p.removeAttribute('tabindex'); else p.setAttribute('tabindex', v);
      p.removeAttribute('data-pfl-tabindex');
    }
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var r = e.intersectionRect;
      e.target.__pflVisible = e.isIntersecting && r.width >= 2 && r.height >= 2;
      if (e.target.parentElement && e.target.parentElement.__pflPopup) evaluate(e.target.parentElement);
    });
  }, { threshold: [0, 0.01, 0.25, 0.5, 1] });

  function evaluate(p) {
    if (!p.isConnected) return;
    var kids = kidsOf(p);
    kids.forEach(function (k) {
      if (!k.__pflObserved) { k.__pflObserved = true; io.observe(k); }
    });
    var open = Date.now() < (p.__pflUntil || 0) ||
      (styleVisible(p) && kids.some(function (k) { return k.__pflVisible && styleVisible(k); }));
    kids.forEach(function (k) { k.inert = !open; });
    if (LOCK_WRAPPER_TABSTOP) wrapperTabstop(p, open);
  }

  function evaluateAll() { popups.forEach(evaluate); }

  function register(p) {
    if (p.__pflPopup) return;
    p.__pflPopup = true;
    popups.push(p);
    p.addEventListener('transitionend', function () { evaluate(p); });
    p.addEventListener('animationend', function () { evaluate(p); });
    new MutationObserver(function () { evaluate(p); }).observe(p, {
      attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'open'],
      childList: true // direct children replaced by the theme
    });
    evaluate(p);
  }

  function scan() { Array.prototype.forEach.call(document.querySelectorAll(POPUPS), register); }

  var raf = 0;
  function scheduleScan() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; scan(); });
  }

  // Open/closed is sometimes toggled with a class on <html>/<body>.
  new MutationObserver(evaluateAll).observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });

  function start() {
    scan();
    new MutationObserver(scheduleScan).observe(document.body, { childList: true, subtree: true }); // popups injected later
    new MutationObserver(evaluateAll).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  // Capture phase on document: runs before any opener handler, so a focus() right after opening is not blocked.
  document.addEventListener('click', function (e) {
  var until = Date.now() + UNLOCK_MS;
  var clickedPopup = e.target.closest ? e.target.closest(POPUPS) : null;
  popups.forEach(function (p) {
    if (p === clickedPopup || (clickedPopup && p.contains(clickedPopup)) || p.contains(e.target)) {
      p.__pflUntil = until;
      evaluate(p);
    }
  });
  [UNLOCK_MS + 20, 600, 1200].forEach(function (t) { setTimeout(evaluateAll, t); });
}, true);

  document.addEventListener('shopify:section:load', scan);
})();
// Mobile menu accessibility
(function () {

  function elementVisible(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.05) return false;
    var r = el.getBoundingClientRect();
    return r.width > 1 && r.height > 1;
  }

  // Catches off-canvas transform: translateX()
  function onScreen(el) {
    if (!elementVisible(el)) return false;
    var r = el.getBoundingClientRect();
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return !(r.right <= 0 || r.bottom <= 0 || r.left >= vw || r.top >= vh);
  }

  function menuOpen() {
    var menu = document.getElementById('mobileMenu');
    return !!menu && onScreen(menu);
  }

  function panelOpen(panel) {
    return menuOpen() && elementVisible(panel);
  }

  function focusables(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      elementVisible
    );
  }

  function stripBadAriaExpanded(root) {
    root.querySelectorAll('a[aria-expanded]').forEach(function (a) { a.removeAttribute('aria-expanded'); });
  }

  /* ---------- Hamburger ---------- */
  function initHamburger() {
    var toggle = document.querySelector('.navbar-toggler[href="#mobileMenu"]');
    var menu = document.getElementById('mobileMenu');
    if (!toggle || !menu) return;
    if (toggle.dataset.a11yHamburgerBound) return;
    toggle.dataset.a11yHamburgerBound = 'true';

    toggle.setAttribute('aria-controls', 'mobileMenu');

    var opener = null;
    var wasOpen = menuOpen();

    function doSync() {
      var open = menuOpen();
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (open && !wasOpen) {
        wasOpen = true;
        opener = toggle;
        setTimeout(function () {
          var items = focusables(menu);
          if (items.length) items[0].focus();
        }, 80);
      } else if (!open && wasOpen) {
        wasOpen = false;
        if (opener && document.contains(opener)) { try { opener.focus(); } catch (e) {} }
        opener = null;
      }
      syncSubmenus();
    }

    // THE FIX: Check immediately, but also check after the slide animation finishes
    function syncExpanded() {
      doSync();
      setTimeout(doSync, 100);
      setTimeout(doSync, 400); 
    }

    new MutationObserver(syncExpanded).observe(menu, { attributes: true, attributeFilter: ['class', 'style', 'inert', 'aria-hidden'] });
    new MutationObserver(syncExpanded).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    new MutationObserver(syncExpanded).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', syncExpanded);

    document.addEventListener('keydown', function (e) {
      if (!menuOpen()) return;

      if (e.key === 'Escape') {
        var close = menu.querySelector('.close-btn');
        if (close) { e.preventDefault(); close.click(); }
        return;
      }

      if (e.key !== 'Tab') return;
      var items = focusables(menu);
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      var inside = menu.contains(document.activeElement);
      if (e.shiftKey && (!inside || document.activeElement === first)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (!inside || document.activeElement === last)) { e.preventDefault(); first.focus(); }
    }, true);

    syncExpanded();
  }

  /* ---------- Submenu toggles ---------- */
  var idCounter = 100;

  function syncSubmenus() {
    document.querySelectorAll('#mobileMenu button.toggle, #mobileMenu button.toggle-level').forEach(function (btn) {
      var panel = btn.nextElementSibling;
      if (!panel || !panel.classList.contains('inner')) return;
      btn.setAttribute('aria-expanded', panelOpen(panel) ? 'true' : 'false');
    });
  }

  function bindSubmenus(root) {
    stripBadAriaExpanded(root);

    root.querySelectorAll('button.toggle, button.toggle-level').forEach(function (btn) {
      var panel = btn.nextElementSibling;
      if (!panel || !panel.classList.contains('inner')) return;

      if (!panel.id) { idCounter++; panel.id = 'submenu-panel-' + idCounter; }
      btn.setAttribute('aria-haspopup', 'true');
      btn.setAttribute('aria-controls', panel.id);

      if (btn.dataset.a11ySubBound) return;
      btn.dataset.a11ySubBound = 'true';

      new MutationObserver(syncSubmenus).observe(panel, { attributes: true, attributeFilter: ['class', 'style'] });

      btn.addEventListener('click', function () {
        setTimeout(syncSubmenus, 0);
        setTimeout(syncSubmenus, 100);
        setTimeout(syncSubmenus, 400);
      });
    });

    syncSubmenus();
  }

  /* ---------- Country/language selector ---------- */
  function initCountrySelector(root) {
    root.querySelectorAll('.detail-summary.country-dropdown-item').forEach(function (summary) {
      var wrapper = summary.closest('.detail-box');
      var expand = wrapper ? wrapper.querySelector('.detail-expand') : null;

      summary.setAttribute('role', 'button');
      summary.setAttribute('tabindex', '0');
      summary.setAttribute('aria-haspopup', 'listbox');

      if (expand) {
        if (!expand.id) { idCounter++; expand.id = 'country-list-' + idCounter; }
        summary.setAttribute('aria-controls', expand.id);
        summary.setAttribute('aria-expanded', elementVisible(expand) ? 'true' : 'false');

        var list = expand.querySelector('ul');
        if (list) list.setAttribute('role', 'listbox');
        expand.querySelectorAll('li').forEach(function (li) { li.setAttribute('role', 'presentation'); });
      }

      if (summary.dataset.a11yBound) return;
      summary.dataset.a11yBound = 'true';

      summary.addEventListener('click', function () {
        setTimeout(function () {
          if (expand) summary.setAttribute('aria-expanded', elementVisible(expand) ? 'true' : 'false');
        }, 50);
      });
      summary.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); summary.click(); }
      });
    });
  }

  function initAll() {
    initHamburger();
    var menu = document.getElementById('mobileMenu');
    if (menu) {
      bindSubmenus(menu);
      initCountrySelector(menu);
    }
  }

  // Fallback to catch click events closing the menu
  document.addEventListener('click', function (e) {
    var menu = document.getElementById('mobileMenu');
    if (!menu) return;
    var toggle = document.querySelector('.navbar-toggler[href="#mobileMenu"]');
    
    // If clicking the close button, trigger the delayed sync to catch the animation
    if (e.target.closest('.close-btn')) {
       setTimeout(syncSubmenus, 400);
    }
  }, true);

  new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
//search popup
(function () {
  if (window.__searchDrawerA11yBound) return;
  window.__searchDrawerA11yBound = true;

  var DRAWER_SELECTOR = '.search-bar-container.classic-search';
  var TRIGGER_SELECTOR = '[data-search-drawer="addsearch"], .yv-dock-item[href="/search"]';
  var CLOSE_SELECTOR = '.yv-search-drawer-close';

  function elementVisible(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.05) return false;
    var r = el.getBoundingClientRect();
    return r.width > 1 && r.height > 1;
  }

  function onScreen(el) {
    if (!elementVisible(el)) return false;
    var r = el.getBoundingClientRect();
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return !(r.right <= 0 || r.bottom <= 0 || r.left >= vw || r.top >= vh);
  }

  function drawerOpen(drawer) {
    return !!drawer && onScreen(drawer);
  }

  function focusables(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      elementVisible
    );
  }

  var opener = null;
  var wasOpen = false;

  function doSync(drawer) {
    var open = drawerOpen(drawer);

    document.querySelectorAll(TRIGGER_SELECTOR).forEach(function (t) {
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    if (open) {
      drawer.removeAttribute('aria-hidden');
      drawer.setAttribute('tabindex', '0');
    } else {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('tabindex', '-1');
    }

    if (open && !wasOpen) {
      wasOpen = true;
      setTimeout(function () {
        var input = drawer.querySelector('#search-drawer-query-input');
        var target = input && elementVisible(input) ? input : focusables(drawer)[0];
        if (target) target.focus();
      }, 80);
    } else if (!open && wasOpen) {
      wasOpen = false;
      if (opener && document.contains(opener)) { try { opener.focus(); } catch (e) {} }
      opener = null;
    }
  }

  function syncWithRetry(drawer) {
    doSync(drawer);
    setTimeout(function () { doSync(drawer); }, 100);
    setTimeout(function () { doSync(drawer); }, 400);
  }

  function init() {
    var drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return;

    if (!drawer.id) drawer.id = 'SearchDrawer';

    document.querySelectorAll(TRIGGER_SELECTOR).forEach(function (t) {
      t.setAttribute('aria-controls', drawer.id);
      if (!t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', 'false');
      if (t.tagName === 'A' && !t.hasAttribute('aria-haspopup')) t.setAttribute('aria-haspopup', 'dialog');

      if (t.dataset.a11ySearchBound) return;
      t.dataset.a11ySearchBound = 'true';
      t.addEventListener('click', function () {
        opener = t;
        syncWithRetry(drawer);
      });
    });

    if (!drawer.dataset.a11yObserverBound) {
      drawer.dataset.a11yObserverBound = 'true';

      new MutationObserver(function () { syncWithRetry(drawer); }).observe(drawer, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });

      new MutationObserver(function () { syncWithRetry(drawer); }).observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });

      document.addEventListener('keydown', function (e) {
        if (!drawerOpen(drawer)) return;

        if (e.key === 'Escape') {
          var closeBtn = drawer.querySelector(CLOSE_SELECTOR);
          if (closeBtn) { e.preventDefault(); closeBtn.click(); }
          return;
        }

        if (e.key !== 'Tab') return;
        var items = focusables(drawer);
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        var inside = drawer.contains(document.activeElement);
        if (e.shiftKey && (!inside || document.activeElement === first)) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && (!inside || document.activeElement === last)) {
          e.preventDefault(); first.focus();
        }
      }, true);
    }

    syncWithRetry(drawer);
  }

  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
//mix bunddle app
/*
 * mw-bundle-a11y.js
 * Accessibility layer for the MW bundle-builder app (product cards + "mw-offers-dialog" product popup).
 *
 * Cards
 *  - "Add to bundle" / "Increase" / "Decrease" / quantity input get the product title in their names.
 *  - The product title becomes a real keyboard control (role=button, tabindex=0, Enter/Space) that opens the popup.
 *  - The duplicate image area is hidden from assistive tech (still clickable with a mouse).
 *  - After add / remove / +/- the change is announced and focus is not lost when the app swaps the controls.
 * Popup (shadow DOM)
 *  - Dialog gets an accessible name + description, close button gets a name, product link says it opens a new tab,
 *    quantity controls get product-specific names.
 *  - Focus moves into the popup on open and returns to the product title on close.
 *
 * The app re-renders with React, so everything is re-applied from a MutationObserver (idempotent).
 */
(function () {
  'use strict';

  var SR_ONLY = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
  var TITLE_SEL = '.Category-ProductCard__ProductTitle';
  var MODAL_TITLE_SEL = '.Products-ProductInfoModal--modalProductTitle';
  var state = { open: false, cardId: null, root: null };
  var roots = [document];
  var seen = new WeakSet();
  var timer = 0;

  function qa(ctx, sel) { return Array.prototype.slice.call(ctx.querySelectorAll(sel)); }
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function set(el, name, val) { if (el.getAttribute(name) !== val) el.setAttribute(name, val); }

  /* ---------- dialog helpers ---------- */
  function findDialog() {
    var hosts = document.querySelectorAll('mw-offers-dialog');
    for (var i = 0; i < hosts.length; i++) {
      var d = hosts[i].shadowRoot && hosts[i].shadowRoot.querySelector('[role="dialog"]');
      if (d) return d;
    }
    return null;
  }

  /* ---------- live region ---------- */
  function announce(root, msg) {
    var live = root.__mwLive;
    if (!live || !live.isConnected) {
      live = document.createElement('div');
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('aria-atomic', 'true');
      live.style.cssText = SR_ONLY;
      (root === document ? document.body : root).appendChild(live);
      root.__mwLive = live;
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 50);
  }

  /* ---------- naming ---------- */
  function fixControls(ctx, title) {
    qa(ctx, 'button.Category-ProductCard__Button').forEach(function (b) {
      var label = txt(b) || 'Add to bundle';
      set(b, 'aria-label', label + ': ' + title);
    });
    qa(ctx, '.Category-ProductCard__QuantityContainer').forEach(function (c) {
      set(c, 'role', 'group');
      set(c, 'aria-label', 'Quantity: ' + title);
    });
    qa(ctx, '.Category-ProductCard__QuantityButton').forEach(function (b) {
      var inc = txt(b).indexOf('+') > -1;
      set(b, 'aria-label', (inc ? 'Increase quantity: ' : 'Decrease quantity: ') + title);
    });
    qa(ctx, '.Category-ProductCard__QuantityDisplay').forEach(function (i) {
      set(i, 'aria-label', 'Quantity: ' + title);
    });
  }

  function fixCard(card) {
    var tEl = card.querySelector(TITLE_SEL);
    if (!tEl) return;
    var title = txt(tEl);
    set(tEl, 'role', 'button');
    set(tEl, 'tabindex', '0');
    set(tEl, 'aria-haspopup', 'dialog');
    set(tEl, 'aria-label', 'View details: ' + title);
    var img = card.querySelector('.Category-ProductCard__ImageContainer');
    if (img) set(img, 'aria-hidden', 'true');
    fixControls(card, title);
  }

  function fixDialog(dlg) {
    var a = dlg.querySelector(MODAL_TITLE_SEL);
    var title = txt(a);
    if (a) {
      if (!a.id) a.id = 'mw-dialog-title';
      set(dlg, 'aria-labelledby', a.id);
      set(a, 'aria-label', title + ' (opens in a new tab)');
    }
    var d = dlg.querySelector('.Products-ProductInfoModal--modalProductDescription');
    if (d) {
      if (!d.id) d.id = 'mw-dialog-desc';
      set(dlg, 'aria-describedby', d.id);
    }
    var c = dlg.querySelector('.Products-ProductInfoModal--modalCloseButton');
    if (c) { set(c, 'type', 'button'); set(c, 'aria-label', 'Close dialog'); }
    fixControls(dlg, title);
  }

  function fixRoot(root) {
    qa(root, '.Category-ProductCard').forEach(fixCard);
    if (root !== document) qa(root, '[role="dialog"]').forEach(fixDialog);
  }

  /* ---------- popup focus management ---------- */
  function checkDialog() {
    var open = !!findDialog();
    if (open && !state.open) {
      state.open = true;
      setTimeout(function () {
        var dlg = findDialog();
        if (!dlg) return;
        var rootNode = dlg.getRootNode();
        if (rootNode.activeElement && dlg.contains(rootNode.activeElement)) return; // app already moved focus in
        var target = dlg.querySelector('.Products-ProductInfoModal--modalCloseButton') ||
          dlg.querySelector('button, a[href], input');
        if (target) target.focus();
      }, 150);
    } else if (!open && state.open) {
      state.open = false;
      setTimeout(function () {
        var ae = document.activeElement;
        if (ae && ae !== document.body) return; // focus already restored
        var root = state.root || document;
        var card = state.cardId && root.getElementById ? root.getElementById(state.cardId) : null;
        var t = card && card.querySelector(TITLE_SEL);
        if (t) t.focus();
      }, 100);
    }
  }

  /* ---------- discovery + observation ---------- */
  function observeRoot(root) {
    if (seen.has(root)) return;
    seen.add(root);
    new MutationObserver(schedule).observe(root === document ? document.body : root, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label']
    });
  }

  function discover() {
    qa(document, '*').forEach(function (el) {
      if (el.shadowRoot && el.localName.indexOf('-') > 0 && roots.indexOf(el.shadowRoot) === -1) {
        roots.push(el.shadowRoot);
        observeRoot(el.shadowRoot);
      }
    });
  }

  function run() {
    timer = 0;
    discover();
    roots.forEach(fixRoot);
    checkDialog();
  }

  function schedule() { if (!timer) timer = setTimeout(run, 60); }

  /* ---------- keyboard: open popup from the title ---------- */
  function openCard(card) {
    var targets = [card.querySelector(TITLE_SEL), card.querySelector('.Category-ProductCard__ImageContainer'), card];
    var i = 0;
    (function next() {
      if (findDialog() || i >= targets.length) return;
      if (targets[i]) targets[i].click();
      i++;
      setTimeout(next, 250);
    })();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var t = (e.composedPath ? e.composedPath()[0] : e.target);
    if (!t || !t.matches || !t.matches(TITLE_SEL + '[role="button"]')) return;
    var card = t.closest('.Category-ProductCard');
    if (!card) return;
    e.preventDefault();
    state.cardId = card.id;
    state.root = card.getRootNode();
    openCard(card);
  });

  /* ---------- clicks: remember trigger, keep focus, announce ---------- */
  document.addEventListener('click', function (e) {
    var t = (e.composedPath ? e.composedPath()[0] : e.target);
    if (!t || !t.closest) return;

    var card = t.closest('.Category-ProductCard');
    if (card && !findDialog()) { state.cardId = card.id; state.root = card.getRootNode(); }

    var btn = t.closest('button.Category-ProductCard__Button, .Category-ProductCard__QuantityButton');
    if (!btn) return;
    var ctx = btn.closest('.Category-ProductCard, .Products-ProductInfoModal--modalActions');
    if (!ctx) return;
    var isQty = btn.classList.contains('Category-ProductCard__QuantityButton');
    var kind = !isQty ? 'add' : (txt(btn).indexOf('+') > -1 ? 'inc' : 'dec');

    setTimeout(function () {
      if (!ctx.isConnected) return;
      var root = ctx.getRootNode();
      var scope = ctx.closest('[role="dialog"]') || ctx;
      var title = txt(scope.querySelector(MODAL_TITLE_SEL + ',' + TITLE_SEL));
      var input = ctx.querySelector('.Category-ProductCard__QuantityDisplay');
      var qty = input ? (input.value || '0') : '0';
      var active = root.activeElement;
      var lost = !active || !ctx.contains(active);

      if (input) {
        if (lost) {
          var target = kind === 'dec' ? ctx.querySelector('.Category-ProductCard__QuantityButton[aria-label^="Decrease"]')
            : ctx.querySelector('.Category-ProductCard__QuantityButton[aria-label^="Increase"]');
          if (target) target.focus();
        }
        announce(root, kind === 'add' ? title + ' added to bundle. Quantity ' + qty : title + ': quantity ' + qty);
      } else if (kind !== 'add') {
        var add = ctx.querySelector('button.Category-ProductCard__Button');
        if (lost && add) add.focus();
        announce(root, title + ' removed from bundle');
      }
    }, 200);
  });

  /* ---------- start ---------- */
  function start() {
    observeRoot(document);
    run();
    setTimeout(run, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', schedule);
})();


(function () {
  if (window.__mwBundleA11y) return;
  window.__mwBundleA11y = true;

  /* Only enhance roots that actually contain this widget's markup */
  var WIDGET_MARKUP = '.CartContent-ItemQuantity--button, .CartContent-Gift--removeButton, .CartContent-BoxSelector--box';

  /* Fix 1: box selector ("Box of 6") — strip fake button semantics entirely.
     It's a lone, non-actionable state display, so remove it from the tab
     order and the accessibility tree's button role. */
  function neutralizeBoxSelectors(root) {
    root.querySelectorAll('.CartContent-BoxSelector--box').forEach(function (el) {
      el.removeAttribute('role');
      el.removeAttribute('tabindex');
    });
  }

  /* Fix 2: quantity buttons → "Increase quantity, <product title>" */
  function fixQuantityButtons(root) {
    root.querySelectorAll('.CartContent-ItemQuantity--button').forEach(function (btn) {
      var item = btn.closest('.CartContent-Item--itemContainer');
      if (!item) return;
      var titleEl = item.querySelector('.CartContent-Item--productTitle');
      var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!title) return;

      var current = btn.getAttribute('aria-label') || '';
      var verb = /increase/i.test(current) ? 'Increase quantity' : 'Decrease quantity';
      btn.setAttribute('aria-label', verb + ', ' + title);

      /* Also names the readonly quantity box, which currently has no accessible name */
      var input = item.querySelector('.CartContent-ItemQuantity--input');
      if (input && !input.getAttribute('aria-label')) {
        input.setAttribute('aria-label', 'Quantity, ' + title);
      }
    });
  }

  /* Fix 3: gift remove button → "Remove <product title>" */
  function fixGiftRemoveButtons(root) {
    root.querySelectorAll('.CartContent-Gift--removeButton').forEach(function (btn) {
      if (btn.dataset.mwA11yRemove) return;
      var wrap = btn.closest('.CartContent-Gift--wrapper') || btn.closest('.CartContent-Gift--container');
      if (!wrap) return;
      var titleEl = wrap.querySelector('.CartContent-Gift--productTitle');
      var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!title) return;
      btn.dataset.mwA11yRemove = 'true';
      btn.setAttribute('aria-label', 'Remove ' + title);
    });
  }

  function enhance(root) {
    if (!root.querySelectorAll) return;
    if (!root.querySelector(WIDGET_MARKUP)) return;
    neutralizeBoxSelectors(root);
    fixQuantityButtons(root);
    fixGiftRemoveButtons(root);
  }

  function watchShadow(shadowRoot) {
    if (shadowRoot.__mwA11yWatched) return;
    shadowRoot.__mwA11yWatched = true;
    enhance(shadowRoot);
    /* widget re-renders on quantity/box changes — re-apply after each render,
       because the app's own templates re-add role="button"/tabindex="0" */
    new MutationObserver(function () { enhance(shadowRoot); }).observe(shadowRoot, {
      childList: true,
      subtree: true
    });
  }

  function findShadowRoots(root) {
    root.querySelectorAll('*').forEach(function (node) {
      if (node.shadowRoot) {
        watchShadow(node.shadowRoot);
        findShadowRoots(node.shadowRoot); /* nested shadow roots too */
      }
    });
  }

  function scan() {
    findShadowRoots(document);
    enhance(document); /* no-op unless the widget ever renders in light DOM */
  }

  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  setTimeout(scan, 300);
  setTimeout(scan, 1000);
})();
//klaviyo heading tag
(function () {
  function fix() {
    document.querySelectorAll('.klaviyo-form-richtext h1').forEach(function (h) {
      if (h.getAttribute('aria-level') !== '2') {
        h.setAttribute('role', 'heading');
        h.setAttribute('aria-level', '2');
      }
    });
  }
  fix();
  var n = 0, t = setInterval(function () { fix(); if (++n > 30) clearInterval(t); }, 500);
  new MutationObserver(fix).observe(document.body, { childList: true, subtree: true });
})();
//
(function () {
  if (window.__yvCardA11y) return;
  window.__yvCardA11y = true;

  /* Keep the theme's hover/drag handlers from swallowing slider button presses */
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (t) {
    document.addEventListener(t, function (e) {
      if (e.target.closest && e.target.closest('.yv-product-card .slider-button')) e.stopPropagation();
    }, true);
  });

  /* Previous / Next image (works for keyboard Enter/Space and mouse) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.yv-product-card .slider-button');
    if (!btn) return;
    e.stopPropagation();
    e.preventDefault();

    var wrap = btn.closest('.yv-product-card-img');
    var el = wrap && wrap.querySelector('.sd-main-Slider');
    if (!el || !window.Flickity) return;

    wrap.classList.add('yv-kb-active', 'slider-active');
    void wrap.offsetWidth; /* make it visible before Flickity measures */

    var f = Flickity.data(el);
    if (!f) {
      try { f = new Flickity(el, JSON.parse(el.getAttribute('data-flickity-hover-slider'))); }
      catch (err) { return; }
    }
    f.resize();
    if (btn.classList.contains('slider-button-next')) { f.next(true); } else { f.previous(true); }
  }, true);

  /* Remove the keyboard-slider state when focus leaves the card */
  document.addEventListener('focusout', function (e) {
    var wrap = e.target.closest && e.target.closest('.yv-product-card-img');
    if (!wrap) return;
    setTimeout(function () {
      if (!wrap.contains(document.activeElement) && !wrap.matches(':hover')) {
        wrap.classList.remove('yv-kb-active');
      }
    }, 0);
  });
})();
//sider state
// Filter drawer a11y override v3
(function () {
  if (window.__yvFilterOverride3) return;
  window.__yvFilterOverride3 = true;

  var nativeSet = Element.prototype.setAttribute;
  var wasOpen = null;
  var visible = new Map();      // element -> is visibly intersecting
  var io = null;
  var observed = new WeakSet();
  var desired = null;

  function T() { return document.getElementById('filterHeading'); }
  function D() { return document.getElementById('filterSideBar'); }

  function opaque(el, stop) {
    for (var n = el; n && n !== stop.parentElement; n = n.parentElement) {
      if (parseFloat(getComputedStyle(n).opacity) < 0.05) return false;
    }
    return true;
  }

  function observeTargets(d) {
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var r = e.intersectionRect;
          visible.set(e.target, e.isIntersecting && e.intersectionRatio > 0.3 && r.width > 5 && r.height > 5);
        });
        sync();
      }, { threshold: [0, 0.3, 0.6, 1] });
    }
    d.querySelectorAll('.yv-filter-title, .filter-heading h3, input, label').forEach(function (el) {
      if (!observed.has(el)) { observed.add(el); io.observe(el); }
    });
  }

  function isOpen(d) {
    if (d.checkVisibility && !d.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true })) return false;
    if (!opaque(d, d)) return false;
    var any = false;
    visible.forEach(function (v, el) { if (v && d.contains(el) && el.isConnected) any = true; });
    return any;
  }

  function lock(t) {
    if (t.__yvLocked) return;
    t.__yvLocked = true;
    t.setAttribute = function (n, v) {
      if (String(n).toLowerCase() === 'aria-expanded') return;
      return nativeSet.apply(this, arguments);
    };
    new MutationObserver(function () {
      if (desired !== null && t.getAttribute('aria-expanded') !== desired) nativeSet.call(t, 'aria-expanded', desired);
    }).observe(t, { attributes: true, attributeFilter: ['aria-expanded'] });
  }

  function sync() {
    var t = T(), d = D();
    if (!t || !d) return;
    lock(t);
    observeTargets(d);

    if (t.getAttribute('role') !== 'button') { d.removeAttribute('inert'); return; }

    var open = isOpen(d);
    desired = open ? 'true' : 'false';
    if (t.getAttribute('aria-expanded') !== desired) nativeSet.call(t, 'aria-expanded', desired);

    if (open) {
      d.removeAttribute('inert');
      if (wasOpen === false && document.activeElement === t) {
        var f = d.querySelector('input:not([disabled]):not([type="hidden"]),button:not([disabled]),a[href]');
        if (f) f.focus();
      }
    } else {
      if (d.contains(document.activeElement)) t.focus();
      nativeSet.call(d, 'inert', '');
    }
    wasOpen = open;
  }

  function burst() { [0, 80, 250, 500, 900].forEach(function (ms) { setTimeout(sync, ms); }); }

  document.addEventListener('click', burst, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var t = T(), d = D();
      if (t && d && isOpen(d) && d.contains(document.activeElement)) t.click();
    }
    burst();
  }, true);
  document.addEventListener('transitionend', sync, true);
  window.addEventListener('resize', burst);
  setInterval(sync, 400);

  // Run  __yvFilterDebug()  in the console to inspect the state
  window.__yvFilterDebug = function () {
    var d = D(), cs = getComputedStyle(d), r = d.getBoundingClientRect();
    console.log({
      open: isOpen(d), ariaExpanded: T().getAttribute('aria-expanded'), inert: d.hasAttribute('inert'),
      checkVisibility: d.checkVisibility && d.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true }),
      opacity: cs.opacity, visibility: cs.visibility, display: cs.display, transform: cs.transform,
      clipPath: cs.clipPath, rect: [r.left, r.right, r.width, r.height],
      parentClass: d.parentElement.className, bodyClass: document.body.className,
      visibleTargets: Array.from(visible.entries()).filter(function (x) { return x[1]; }).length
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', burst);
  else burst();
})();
//captcha aria label
(function () {
  function fixHCaptchaTextareas() {
    // Match any hCaptcha response textarea (ID changes on every load)
    document.querySelectorAll('textarea[name="h-captcha-response"], textarea[id^="h-captcha-response"]').forEach(function (el) {
      // Only add if it has no accessible name yet
      if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
        el.setAttribute('aria-label', 'hCaptcha response');
      }
    });
  }

  function init() {
    fixHCaptchaTextareas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // hCaptcha injects the textarea dynamically, so watch for it
  new MutationObserver(function () {
    init();
  }).observe(document.body, { childList: true, subtree: true });
})();
//image gallery popup
/**
 * Fancybox gallery accessibility fixes
 *  1. Descriptive aria-labels on the buttons (replaces title)
 *  2. Alt text on gallery images, copied from the alt already set in Shopify
 *  3. A meaningful dialog name, and decorative icons hidden from screen readers
 *
 * Add before </body> in theme.liquid, wrapped in <script>...</script>,
 * or upload as an asset and load with {{ 'fancybox-a11y.js' | asset_url | script_tag }}
 */
(function () {
  'use strict';

  var DIALOG_LABEL = 'Product image gallery';

  // [selector, label]
  var BUTTON_LABELS = [
    ['[data-fancybox-close], .fancybox__button--close', 'Close image gallery popup'],
    ['.carousel__button.is-next', 'Next slide'],
    ['.carousel__button.is-prev', 'Previous slide'],
    ['.fancybox__button--zoom', 'Zoom image'],
    ['.fancybox__button--slideshow, .fancybox__button--autoplay', 'Toggle slideshow'],
    ['.fancybox__button--fullscreen', 'Toggle full screen'],
    ['.fancybox__button--thumbs', 'Toggle thumbnails'],
    ['.fancybox__button--download', 'Download image']
  ];

  /* Reduce an image URL to a comparable file name:
     //cdn/shop/files/Name_800x.jpg?v=123&width=1100  ->  name.jpg */
  function fileKey(url) {
    if (!url) return '';
    url = String(url).split('#')[0].split('?')[0];
    var name = url.substring(url.lastIndexOf('/') + 1);
    try { name = decodeURIComponent(name); } catch (e) {}
    name = name.replace(/_(?:\d+x\d*|\d*x\d+)(?:_crop_\w+)?(?=\.[a-z0-9]+$)/i, '');
    return name.toLowerCase();
  }

  /* Collect alt text from the images already on the page (outside the gallery popup) */
  function buildAltMap() {
    var map = {};

    document.querySelectorAll('img').forEach(function (img) {
      if (img.closest('.fancybox__container')) return;
      var alt = (img.getAttribute('alt') || '').trim();
      if (!alt) return;

      var urls = [
        img.currentSrc,
        img.getAttribute('src'),
        img.getAttribute('data-src'),
        img.getAttribute('data-original')
      ];
      (img.getAttribute('srcset') || '').split(',').forEach(function (part) {
        urls.push(part.trim().split(' ')[0]);
      });
      (img.getAttribute('data-srcset') || '').split(',').forEach(function (part) {
        urls.push(part.trim().split(' ')[0]);
      });

      urls.forEach(function (u) {
        var key = fileKey(u);
        if (key && !map[key]) map[key] = alt;
      });
    });

    // Links that open the gallery point at the full-size image, so match on their href too
    document.querySelectorAll('[data-fancybox]').forEach(function (link) {
      var inner = link.querySelector('img');
      var alt = (link.getAttribute('data-alt') || (inner && inner.getAttribute('alt')) || '').trim();
      var key = fileKey(link.getAttribute('href'));
      if (alt && key && !map[key]) map[key] = alt;
    });

    return map;
  }

  function pageTitle() {
    var h1 = document.querySelector('h1');
    return h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function fix(container) {
    // Dialog name (the default text just says how to close it)
    container.setAttribute('aria-label', DIALOG_LABEL);

    // Button names: aria-label instead of title
    BUTTON_LABELS.forEach(function (pair) {
      container.querySelectorAll(pair[0]).forEach(function (btn) {
        btn.setAttribute('aria-label', pair[1]);
        btn.removeAttribute('title');
      });
    });

    // Any other button that only has a title: promote it to aria-label
    container.querySelectorAll('button[title]:not([aria-label])').forEach(function (btn) {
      btn.setAttribute('aria-label', btn.getAttribute('title'));
      btn.removeAttribute('title');
    });

    // Icons inside the buttons are decorative (they were role="img" with no name)
    container.querySelectorAll('button svg').forEach(function (svg) {
      svg.removeAttribute('role');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    });

    // The thumbnail strip is background images and is not keyboard operable
    container.querySelectorAll('.fancybox__thumbs').forEach(function (thumbs) {
      thumbs.setAttribute('aria-hidden', 'true');
    });

    // Alt text for gallery images
    var images = Array.prototype.filter.call(
      container.querySelectorAll('.fancybox__slide img'),
      function (img) { return !(img.getAttribute('alt') || '').trim(); }
    );
    if (!images.length) return;

    var altMap = buildAltMap();
    var title = pageTitle();

    images.forEach(function (img) {
      var alt = altMap[fileKey(img.getAttribute('src'))];

      // Fallback if no matching image with alt text is found on the page
      if (!alt && title) {
        var slide = img.closest('.fancybox__slide');
        var index = slide ? parseInt(slide.getAttribute('data-index'), 10) : NaN;
        alt = isNaN(index) ? title : title + ' - image ' + (index + 1);
      }

      if (alt) img.setAttribute('alt', alt);
    });
  }

  function watch(container) {
    if (container.getAttribute('data-a11y-watched')) return;
    container.setAttribute('data-a11y-watched', 'true');

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        fix(container);
      });
    }

    fix(container);

    // Slides and images are created as you move through the gallery
    new MutationObserver(schedule).observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src']
    });
  }

  // Fancybox appends its container to <body> when the gallery opens
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && node.classList.contains('fancybox__container')) {
          watch(node);
        }
      });
    });
  }).observe(document.body, { childList: true });

  document.querySelectorAll('.fancybox__container').forEach(watch);
})();
//open in  new tab
(function () {
  var FLAG = 'data-a11y-newtab-done';
  var NOTICE_TEXT = '(opens in a new tab)';

  function injectVisuallyHiddenStyle() {
    if (document.getElementById('a11y-newtab-style')) return;
    var style = document.createElement('style');
    style.id = 'a11y-newtab-style';
    style.textContent =
      '.a11y-newtab-notice{' +
      'position:absolute!important;' +
      'width:1px!important;height:1px!important;' +
      'padding:0!important;margin:-1px!important;' +
      'overflow:hidden!important;' +
      'clip:rect(0,0,0,0)!important;' +
      'white-space:nowrap!important;' +
      'border:0!important;' +
      '}';
    document.head.appendChild(style);
  }

  function processLink(link) {
    if (link.hasAttribute(FLAG)) return;
    if (link.getAttribute('target') !== '_blank') return;

    link.setAttribute(FLAG, 'true');

    // Best practice safety: ensure noopener/noreferrer without
    // overriding anything already explicitly set.
    var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    ['noopener', 'noreferrer'].forEach(function (token) {
      if (rel.indexOf(token) === -1) rel.push(token);
    });
    link.setAttribute('rel', rel.join(' '));

    // Avoid duplicating the notice if accessible name already
    // mentions "new tab" / "new window" somehow.
    var existingText = (link.getAttribute('aria-label') || link.textContent || '').toLowerCase();
    if (existingText.indexOf('new tab') !== -1 || existingText.indexOf('new window') !== -1) {
      return;
    }

    var notice = document.createElement('span');
    notice.className = 'a11y-newtab-notice';
    notice.textContent = ' ' + NOTICE_TEXT;
    link.appendChild(notice);
  }

  function processAll(root) {
    var scope = root || document;
    var links = scope.querySelectorAll('a[target="_blank"]:not([' + FLAG + '])');
    links.forEach(processLink);
  }

  function init() {
    injectVisuallyHiddenStyle();
    processAll(document);

    // Catch links added later (AJAX cart drawers, quick view,
    // dynamically loaded sections, infinite scroll, etc.)
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('a[target="_blank"]')) {
            processLink(node);
          }
          if (node.querySelectorAll) {
            processAll(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
//Iframe title
(function () {
  var TITLE = "A MESSAGE FROM OUR FOUNDER SCOTT APPERLEY Co-Founder & CEO";

  function addTitle(root) {
    root.querySelectorAll('iframe[data-video-src*="LqX2qh-dRug"], iframe[src*="LqX2qh-dRug"]').forEach(function (frame) {
      if (frame.getAttribute('title') !== TITLE) {
        frame.setAttribute('title', TITLE);
      }
    });
  }

  // Run now (or once DOM is ready)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { addTitle(document); });
  } else {
    addTitle(document);
  }

  // Catch iframes added or swapped in later
  new MutationObserver(function () { addTitle(document); })
    .observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'data-video-src'] });
})();
